import React, {useEffect, useContext} from 'react'

// import context
import { Context } from '../courseTemplates';
import AudioPageLink from './audioPageLink';

/**
 * Prior courses component
 * @param {Object} priorCourses - Data for the prior courses
 */
function PriorCourses({priorCourses}) {
    // get our global context variables
    const value = useContext(Context);
    const { customerId } = value;

    /**
     * Gets seat JSX for a prior course
     * @param {Object} courseData - Course Data
     * @returns 
     */
    const getPriorSeat = (courseData) => {
        // if it was an online course, don't show the seat number but show the online course text instead
        if(courseData.digitalCourse){
            return(
                <>
                    Digital Course
                </>
            )
        }
        // if there is a seat number
        if(courseData.seat && courseData.seat.seatNumber){
            const seat = courseData.seat.seatNumber;
        
            return(
                <>
                    Seat {seat} | <a href="#" className="seating-popup" data-customerid={customerId} data-courseid={courseData.CourseRecordID} data-categoryid={courseData.enrollmentCategoryRecordId}>View</a>
                </>
            )
        // if there is a seat just return the room name
        } else if (courseData.seat && courseData.seat.classroom) {
            return (
                <>
                    {courseData.seat.classroom}
                </>
            )
        }
    }

    useEffect(() => {
        // trigger the jquery to initiate the seating popups
        const InitSeatingPopupsEv = new Event('initSeatingPopups');
        document.body.dispatchEvent(InitSeatingPopupsEv);
    },[]);

    // Component level JSX return statement ******************************************************
    return (
        <>
            {priorCourses.length > 0 &&
                <div className="block-panel">
                    <h4 className="block-panel__header h2">Prior Courses</h4>
                    <div className="block-panel__content">

                        <div className="table-course-list">

                            {priorCourses.map((priorCourse) => {
                                return(
                                    <div className="table-course-list__row responsive-grid rg-align-items-center">
                                        <div className="rg-5 rg-sm-12 rg-xs-12">
                                            <h4 className="cell-headline">{priorCourse.dateAttended}</h4>
                                            {priorCourse.attendedAs && priorCourse.attendedAs.trim() !== '' && (
                                                <>{priorCourse.attendedAs}</>
                                            )}
                                        </div>
                                        <div className="rg-3 rg-sm-12 rg-xs-12">
                                            <div className="headline-label headline-label--txt-color">
                                                {getPriorSeat(priorCourse)}
                                            </div>
                                        </div>
                                        <div className="rg-4 rg-sm-12 rg-xs-12">
                                            {/* Maybe one day.... */}
                                            {/* <a className="text-btn-arrow" href="">See Payment Details<span className="link-arrow"><IconTxtBtnArrow/></span></a> */}
                                            {priorCourse?.digitalCourse && priorCourse?.audioFilesPage &&
                                                <AudioPageLink url={priorCourse?.audioFilesPage}/>
                                            }
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default PriorCourses;